// extracted by mini-css-extract-plugin
module.exports = {"container":"question-form_container__3oy3N","buttonContainer":"question-form_buttonContainer__3UWGm","status":"question-form_status__1GC57"};